function ReplyIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 50"
      fill="#AEAAB5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#fff" d="M0 0h50v50H0z" />
      <path d="M24.5 4C10.997 4 0 13.618 0 25.5S10.997 47 24.5 47c4.932 0 9.46-1.293 13.341-3.476 3.477 2.102 7.197 2.021 9.38 1.698a.644.644 0 00.242-1.213c-2.102-1.374-3.234-3.313-3.88-5.01C46.977 35.28 49 30.591 49 25.5 49.08 13.618 38.084 4 24.5 4zm8.409 23.844h-9.945l1.132 1.132 2.991 2.99-3.315 3.314-2.992-2.99-3.477-3.476-2.425-2.425-.89-.889 2.992-2.99 6.792-6.79 3.315 3.314-4.123 4.122h12.128v4.688H32.91z" />
    </svg>
  )
}

export default ReplyIcon
